import { memo } from 'react';
import { ImageBackground, StyledZoomContainer } from '../styles';
import { MediaFileProps } from './media-file.types';
import { useMedia } from 'components/media/media.context';

export const ImageFile = memo((props: MediaFileProps) => {
  const { file, view = 'full' } = props;
  const { dispatch } = useMedia();

  const imageStyles = {
    objectFit: view === 'full' ? 'contain' : 'cover',
  } as const;

  const handleLoad = () => {
    dispatch({
      type: 'MEDIA/MEDIA_LOADED',
      id: file.id,
    });
  };

  const handleError = () => {
    dispatch({
      type: 'MEDIA/MEDIA_ERROR',
      id: file.id,
    });
  };

  if (view === 'thumbnail') {
    return (
      <img
        src={file.url}
        alt=""
        style={imageStyles}
        loading="lazy"
        onLoad={handleLoad}
        onError={handleError}
      />
    );
  }

  return (
    <>
      <ImageBackground $fileUrl={file.url} />
      <StyledZoomContainer>
        <img
          src={file.url}
          alt=""
          style={imageStyles}
          loading="lazy"
          onLoad={handleLoad}
          onError={handleError}
        />
      </StyledZoomContainer>
    </>
  );
});
